module.exports = __webpack_public_path__ + "img/trash-access-direction.3c97d26c.svg";